/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DownloadManagementListContentRequest = {
    statuses?: Array<string>;
    name?: string;
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: DownloadManagementListContentRequest.direction | null;
};

export namespace DownloadManagementListContentRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

